import React, { Fragment } from "react";
import { Footerlight, PageLayout } from "../../../Constant";
import AreaContainer from "./AreaList";

const Area = () => {
    return (
        <Fragment>
            <AreaContainer mainTitle={Footerlight} title={Footerlight} parent={PageLayout} />  
        </Fragment>
    )
}
export default Area;